var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConcentricCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3924 72.7848C70.3706 72.7848 72.7848 70.3706 72.7848 67.3924C72.7848 64.4143 70.3706 62 67.3924 62C64.4143 62 62 64.4143 62 67.3924C62 70.3706 64.4143 72.7848 67.3924 72.7848Z",
    stroke: "#668598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1266 79.2532C73.8239 79.2532 79.2532 73.8239 79.2532 67.1266C79.2532 60.4293 73.8239 55 67.1266 55C60.4293 55 55 60.4293 55 67.1266C55 73.8239 60.4293 79.2532 67.1266 79.2532Z",
    stroke: "#668598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8608 85.7216C78.2773 85.7216 86.7216 77.2773 86.7216 66.8608C86.7216 56.4443 78.2773 48 67.8608 48C57.4443 48 49 56.4443 49 66.8608C49 77.2773 57.4443 85.7216 67.8608 85.7216Z",
    stroke: "#668598"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5949 92.1898C81.7306 92.1898 93.1898 80.7306 93.1898 66.5949C93.1898 52.4592 81.7306 41 67.5949 41C53.4592 41 42 52.4592 42 66.5949C42 80.7306 53.4592 92.1898 67.5949 92.1898Z",
    stroke: "#668598"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3291 99.6582C85.184 99.6582 99.6582 85.184 99.6582 67.3291C99.6582 49.4742 85.184 35 67.3291 35C49.4742 35 35 49.4742 35 67.3291C35 85.184 49.4742 99.6582 67.3291 99.6582Z",
    stroke: "#668598"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0633 106.127C88.6374 106.127 106.127 88.6374 106.127 67.0633C106.127 45.4892 88.6374 28 67.0633 28C45.4892 28 28 45.4892 28 67.0633C28 88.6374 45.4892 106.127 67.0633 106.127Z",
    stroke: "#668598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7975 112.595C92.0908 112.595 112.595 92.0908 112.595 66.7975C112.595 41.5042 92.0908 21 66.7975 21C41.5042 21 21 41.5042 21 66.7975C21 92.0908 41.5042 112.595 66.7975 112.595Z",
    stroke: "#668598"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5316 119.063C96.544 119.063 120.063 95.544 120.063 66.5316C120.063 37.5192 96.544 14 67.5316 14C38.5192 14 15 37.5192 15 66.5316C15 95.544 38.5192 119.063 67.5316 119.063Z",
    stroke: "#668598"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2658 126.532C99.9974 126.532 126.532 99.9974 126.532 67.2658C126.532 34.5342 99.9974 8 67.2658 8C34.5342 8 8 34.5342 8 67.2658C8 99.9974 34.5342 126.532 67.2658 126.532Z",
    stroke: "#668598"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67 133C103.451 133 133 103.451 133 67C133 30.5492 103.451 1 67 1C30.5492 1 1 30.5492 1 67C1 103.451 30.5492 133 67 133Z",
    stroke: "#668598"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcentricCircles);
export default __webpack_public_path__ + "static/media/ConcentricCircles.9b117d50.svg";
export { ForwardRef as ReactComponent };